export enum ActionTypes {
  GET_ML_STATS = '[ML] GetMlStats',
  GET_CAR_ML_INFO = '[ML] GetCarMlInfo',
  GET_ALL_ML_INFO = '[ML] GetAllMlInfo',
  GET_MAKE_AND_MODEL_DATA = '[ML] GetMakeAndModelData',
  TRAIN_MODEL = '[ML] TrainModel',
  GET_TRAINING_HISTORY = '[ML] GetTrainingHistory',
  GET_SIMULATIONS_METADATA = '[ML] GetSimulationsMetadata',
  GET_SIMULATIONS_RESPONSE = '[ML] GetSimulationsResponse',
  SIMULATE_PRICE = '[ML] SimulatePrice',
  CREATE_DATASET = '[ML] CreateDataset',
}

export class GetMlStats {
  static readonly type = ActionTypes.GET_ML_STATS;
}

export class GetMakeAndModelData {
  static readonly type = ActionTypes.GET_MAKE_AND_MODEL_DATA;
}

export class GetCarMlInfo {
  static readonly type = ActionTypes.GET_CAR_ML_INFO;

  constructor(public payload: { carMake: string; carModel: string }) {
  }
}

export class GetAllMlInfo {
  static readonly type = ActionTypes.GET_ALL_ML_INFO;
}

export class TrainModel {
  static readonly type = ActionTypes.TRAIN_MODEL;

  constructor(public payload: { [k: string]: any }) {
  }
}

export class SimulatePrice {
  static readonly type = ActionTypes.SIMULATE_PRICE;

  constructor(public payload: { [k: string]: any }) {
  }
}

export class CreateDataset {
  static readonly type = ActionTypes.CREATE_DATASET;

  constructor(public payload: { [k: string]: any }) {
  }
}

export class GetTrainingHistory {
  static readonly type = ActionTypes.GET_TRAINING_HISTORY;

  constructor(public payload: { carMake: string; carModel: string }) {
  }
}

export class GetSimulationsMetadata {
  static readonly type = ActionTypes.GET_SIMULATIONS_METADATA;
}

export class GetSimulationsResponse {
  static readonly type = ActionTypes.GET_SIMULATIONS_RESPONSE;

  constructor(public payload: { timestamp: string }) {
  }
}

